module.exports = __webpack_public_path__ + "img/instellingen-icon.6892f50.png";